import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchBrandGroup,
  SearchBrandGroupVariables
} from "./types/SearchBrandGroup";

export const searchBrandGroup = gql`
  ${pageInfoFragment}
  query SearchBrandGroup(
    $after: String
    $first: Int!
    $query: String!
    $status: String!
    $malls: [ID]
  ) {
    search: brandGroups(
      after: $after
      first: $first
      filter: { search: $query, status: $status, malls: $malls }
    ) {
      edges {
        node {
          id
          name
          code
          classification
          category
          vertical
          sellers {
            id
            name
            legalName
            tenants(mallIds: $malls) {
              id
              storeName
            }
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<SearchBrandGroup, SearchBrandGroupVariables>(
  searchBrandGroup
);
